import React from 'react'
import './Learn.css'
import { useEffect } from 'react'
import { FaHandshake, FaIcons, FaMedal, FaTrophy } from 'react-icons/fa'
import { FaLightbulb, FaStar } from 'react-icons/fa6'
import { useInView } from 'react-intersection-observer'

export default function Learn() {

    return (
        <div className='learn-container' id="about">
            <div className='learn-bottom'>
                <div className='learn-left'>
                    <img className='im-learn' src='16.png' />
                </div>
                <div className='learn-next'>
                    <hr className='inspire-line'></hr>
                    <h2 className='head-1'>
                        About Us
                    </h2>
                    <p className='para-learn'>
                        Welcome to NEED 3 Solutions, your trusted partner in web, software,
                        and mobile app development. We specialize in delivering cutting-edge,
                        customized digital solutions that drive business success. Our team of
                        experienced professionals is dedicated to transforming your ideas into
                        innovative and functional applications, ensuring top-quality service
                        and client satisfaction. Discover the difference with NEED 3 Solutions,
                        where technology meets excellence.
                    </p>
                    <div className='learn-analytics'>
                        <div className='learn-analytics-inner'>
                            <FaLightbulb className='learn-icon learn-icon1' />
                            <p className='learn-text'>
                                Innovation
                            </p>
                            <hr className='learn-line'>
                            </hr>
                        </div>
                        <div className='learn-analytics-inner'>
                            <FaStar className='learn-icon learn-icon2' />
                            <p className='learn-text'>
                                Excellence
                            </p>
                            <hr className='learn-line'>
                            </hr>
                        </div>
                        <div className='learn-analytics-inner'>
                            <FaHandshake className='learn-icon learn-icon3' />
                            <p className='learn-text'>
                                Professionalism
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
